import { activity } from '../../../utility/data';
import './greenRedOutlinedButtons.scss';
import PropTypes from 'prop-types';

function GreenRedOutlinedButtons({
  greenOnPress,
  redOnPress,
  greenName,
  redName,
  activeGreenCondition,
  notDeletable,
}) {
  const showActive = typeof activeGreenCondition === 'boolean';

  return (
    <div className="greenRedOutlinedButtons">
      <button
        className={`validationButton ${showActive && activeGreenCondition ? 'buttonActive' : ''}`}
        onClick={greenOnPress}
        type="button"
      >
        {greenName}
      </button>
      {!notDeletable && (
        <button
          className={`cancelButton ${showActive && !activeGreenCondition ? 'buttonActive' : ''}`}
          onClick={redOnPress}
          type="button"
        >
          {redName}
        </button>
      )}
    </div>
  );
}

GreenRedOutlinedButtons.propTypes = {
  greenOnPress: PropTypes.func,
  redOnPress: PropTypes.func,
  greenName: PropTypes.string,
  redName: PropTypes.string,
  activityGreenCondition: PropTypes.bool,
  notDeletable: PropTypes.bool,
};

export default GreenRedOutlinedButtons;
